import { Observable } from 'rxjs/internal/Observable';
import { TokenRefreshToken } from './models';

export abstract class TokenProvider {
  public abstract getToken(): Observable<TokenRefreshToken>;
}
